// Consent Mode V2 manager — defaults to DENIED.
// Single source of truth for the consent state, persisted in localStorage.
const KEY = "icb_consent_v1";

const DEFAULTS = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  // Always granted (functional / RGPD legitimate interest):
  functionality_storage: "granted",
  security_storage: "granted",
  wait_for_update: 500,
};

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

function pushDefault(state) {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  function gtag() { window.dataLayer.push(arguments); }
  gtag("consent", "default", state);
}

function pushUpdate(state) {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag("consent", "update", state);
}

/** Call this BEFORE any GA script loads — sends the default consent state to GTAG. */
export function initConsentDefaults() {
  const saved = readConsent();
  const state = saved
    ? {
        ad_storage: saved.ads ? "granted" : "denied",
        ad_user_data: saved.ads ? "granted" : "denied",
        ad_personalization: saved.ads ? "granted" : "denied",
        analytics_storage: saved.analytics ? "granted" : "denied",
        functionality_storage: "granted",
        security_storage: "granted",
      }
    : DEFAULTS;
  pushDefault(state);
  return saved;
}

/** Persist user choice and broadcast a consent update to GTAG. */
export function setConsent({ analytics, ads }) {
  const decision = { analytics: !!analytics, ads: !!ads, ts: Date.now() };
  try { localStorage.setItem(KEY, JSON.stringify(decision)); } catch { /* noop */ }
  pushUpdate({
    ad_storage: ads ? "granted" : "denied",
    ad_user_data: ads ? "granted" : "denied",
    ad_personalization: ads ? "granted" : "denied",
    analytics_storage: analytics ? "granted" : "denied",
  });
  // Notify listeners (analytics loader will pick up the change)
  try { window.dispatchEvent(new CustomEvent("icb:consent-update", { detail: decision })); } catch { /* noop */ }
  return decision;
}

export function hasDecision() {
  return !!readConsent();
}
